import React from "react";
import Buttons, { EnumButtonType, EnumButtonWeight, EnumColors } from "../../Buttons/Buttons/Buttons";
import styles from "./Confirm.module.css";
import { useAppSelector } from "../../../../hooks/redux";
import { getLanguage } from "../../../../store/selectors/appSelector";
import { getTextByLanguage } from "../../../../enums/utils/getTextByLanguage";
import { UIText } from "../../../../enums/UIText/UIText";

type IProps = {
	text: string;
	callback: () => void;
	callbackCancel: () => void;
	loading?: boolean;
};
const Confirm = (props: IProps) => {
	const language = useAppSelector(getLanguage);

	console.log(props.loading);

	return (
		<div className={styles.wrapper}>
			<span className={styles.triangle}></span>
			<div>{props.text}</div>
			<div className={styles.controls}>
				<Buttons
					loading={props.loading}
					disabled={props.loading}
					type={EnumButtonType.filled}
					weight={EnumButtonWeight.slim}
					color={EnumColors.gold}
					onClick={props.callback}
				>
					{getTextByLanguage(UIText.actions.cancel, language)}
				</Buttons>
				<Buttons
					type={EnumButtonType.filled}
					weight={EnumButtonWeight.slim}
					color={EnumColors.white}
					onClick={props.callbackCancel}
				>
					{getTextByLanguage(UIText.actions.save, language)}
				</Buttons>
			</div>
		</div>
	);
};

export default Confirm;
